import Select from '../../../components/Select';

import styles from './selectField.module.css';

export interface SelectFieldOption {
  label: string;
  value: string;
}

export interface SelectFieldProps {
  label: string;
  value?: string;
  options: readonly SelectFieldOption[];
  disabled?: boolean;
  onChange: (value: string) => void;
}

const SelectField = ({
  label,
  value,
  options,
  disabled = false,
  onChange
}: SelectFieldProps) => {
  return (
    <div className={styles.field}>
      <span className={styles.label}>{label}</span>
      <Select
        className={styles.select}
        value={value}
        options={[...options]}
        disabled={disabled}
        onSelect={selectedValue => onChange(String(selectedValue))}
      />
    </div>
  );
};

export default SelectField;
